var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_REVIEWS = 'api/review';
export const getList = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr(['sortBy'], params);
            return yield this.axiosInstance.get(`${GET_SET_REVIEWS}/${storeId}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
export const requestStoreReviewByCustomerId = function (storeId, customerId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_REVIEWS}/request/${storeId}/${customerId}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
